var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.277105 11.9998C0.232725 11.9998 0.187804 11.989 0.147212 11.9674C0.0568286 11.9192 0 11.825 0 11.7227V0.277073C0 0.174782 0.0562869 0.0806057 0.147212 0.0324449C0.237595 -0.0157242 0.347462 -0.00977062 0.432436 0.047058L8.92694 5.76996C9.00325 5.82138 9.04926 5.90743 9.04926 5.99999C9.04926 6.09199 9.00325 6.17805 8.92694 6.23001L0.43202 11.9529C0.385475 11.9843 0.331353 12 0.277229 12L0.277105 11.9998Z","fill":"currentColor"}));
}

Play.defaultProps = {"width":"10","height":"12","viewBox":"0 0 10 12","fill":"none"};

module.exports = Play;

Play.default = Play;
